import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckBadgeFill = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "#000",
		fillRule: "evenodd",
		d: "M7.716 1.532a.75.75 0 0 0-.78.224L5.303 3.622l-2.332.931a.75.75 0 0 0-.472.696L2.496 7.57 1.13 9.576a.75.75 0 0 0 .02.871l1.346 1.803.004 2.501a.75.75 0 0 0 .471.695l2.333.934 1.632 1.864a.75.75 0 0 0 .711.241l2.35-.47 2.354.47a.75.75 0 0 0 .711-.241l1.632-1.864 2.332-.934a.75.75 0 0 0 .472-.695l.004-2.501 1.347-1.803a.75.75 0 0 0 .019-.871L17.502 7.57l-.004-2.321a.75.75 0 0 0-.472-.696l-2.332-.93-1.632-1.867a.75.75 0 0 0-.78-.224l-2.284.685-2.282-.685Zm6.05 6.762a.75.75 0 0 0-1.032-1.088l-4.26 4.035-1.236-1.06a.75.75 0 1 0-.976 1.138l1.75 1.5a.75.75 0 0 0 1.004-.025l4.75-4.5Z",
		clipRule: "evenodd"
	})]
});
const ForwardRef = forwardRef(SvgCheckBadgeFill);
export { ForwardRef as ReactComponent };
